import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/audit-trail`;

export const auditTrailService = {
  getRecent: async ({ limit = 100, offset = 0 } = {}) => {
    const response = await axios.get(`${API_BASE}?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  getByEntity: async (entityType, entityId, { limit = 50, offset = 0 } = {}) => {
    const response = await axios.get(`${API_BASE}/entity/${entityType}/${entityId}?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  getByActor: async (actorId, { limit = 50, offset = 0 } = {}) => {
    const response = await axios.get(`${API_BASE}/actor/${actorId}?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  getByActionType: async (actionType, { limit = 50, offset = 0 } = {}) => {
    const response = await axios.get(`${API_BASE}/action/${actionType}?limit=${limit}&offset=${offset}`);
    return response.data;
  }
};

export default auditTrailService;
